import styled from 'styled-components'

import { palette, fonts, mediaQueries } from '../../styles/variables'
import { translate, pushWithLanguageRoutes } from '../../utils/translation'
import { DefaultButton, PrimaryButton } from '../buttons/Buttons'
import { Text } from '../topography'
import Icon from '../icon/Icon'
import warning from '../../styles/assets/warning-small.svg'
import people from '../../styles/assets/people.svg'

import Modal, { ModalHeader, ModalContent, ModalFooter } from './Modal'

const Title = styled.span({
  color: palette.darkGray,
  fontSize: 24,
  fontFamily: fonts.primaryBook,
  textAlign: 'center',
  marginLeft: '8px',
  [mediaQueries.mobile]: {
    fontSize: '18px',
    marginLeft: 0,
    marginTop: 20,
    transform: 'translateX(0)',
  },
})

const Row = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  [mediaQueries.mobile]: {
    flexDirection: 'column',
  },
})

const desktopStyle = {}

const mobileStyle = {
  width: '90%',
  height: 'auto',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-around',
}

const PModalFooter = styled(ModalFooter)({})

const FooterSection = styled.div({
  display: 'flex',
  justifyContent: 'center',
  width: '100%',

  '& button': {
    [mediaQueries.mobile]: {
      marginTop: '15px',
    },
  },

  '& button + button': {
    [mediaQueries.mobile]: {
      marginTop: '0px',
    },
  },

  [mediaQueries.mobile]: {
    flexDirection: 'column-reverse',
    justifyContent: 'center',
    alignItems: 'center',
  },
})

const LoginLimitModal = ({
  type,
  title,
  message,
  onClose,
  isOpen,
  onRedirect,
  testId,
  ...rest
}) => (
  <Modal
    isOpen={isOpen}
    desktopStyle={desktopStyle}
    mobileStyle={mobileStyle}
    {...rest}
  >
    <ModalHeader data-testid={`${testId}-header`}>
      <Row>
        <Icon src={warning} transform="translateX(-50%)" />
        <Title>{title}</Title>
      </Row>
    </ModalHeader>
    <ModalContent style={{ height: 'calc(100% - 200px)' }}>
      <Text
        color={palette.darkGray}
        fontFamily={fonts.primaryLight}
        textAlign="center"
        lineHeight="25px"
        whiteSpace="pre-wrap"
        mobilePadding="0 20px"
      >
        {message}
      </Text>
    </ModalContent>
    <PModalFooter>
      <FooterSection>
        <PrimaryButton
          testId="dismiss-button"
          theme="orange"
          onClick={onClose}
          tag={
            type === 'SIGN_OUT_WARNING'
              ? translate('got_it_button')
              : translate('dismiss_button')
          }
          width="fit-content"
          mobileWidth="100%"
          mobileStyles={{
            flex: 1,
          }}
        />
        {type === 'LOGIN_LIMIT_REACHED' && (
          <DefaultButton
            static
            onClick={() => {
              pushWithLanguageRoutes('/settings/account_billing')
              onRedirect()
            }}
            style={{ height: '50px' }}
            width="fit-content"
            mobileStyles={{
              flex: 1,
              width: '100%',
              justifyContent: 'center',
              gap: 5,
            }}
          >
            <Icon src={people} />
            {translate('add_user_button')}
          </DefaultButton>
        )}
      </FooterSection>
    </PModalFooter>
  </Modal>
)

export default LoginLimitModal
